<div class="container-fluid dashboard-wrapper">
  <div class="row">
    <div class="col-12 col-lg-9">
      <div class="row dashboard-map-wrapper">
        <div class="col">
          <ng-container *appFeature="'SiteMap'">
            <ng-container *ngIf="isSitesLoading$ | async; else content">
              <div
                class="google-map-wrapper d-flex align-items-center justify-content-center flex-column"
                [style.height]="'31.25rem'">
                <mat-spinner
                  strokeWidth="6"
                  diameter="75"
                  [mode]="'indeterminate'"
                  style="overflow: visible"></mat-spinner>
              </div>
            </ng-container>
            <ng-template #content>
              <app-google-map
                *ngIf="allActiveSitesForMap$ | async"
                [locations$]="allActiveSitesForMap$"
                [mapHeight]="'31.25rem'">
              </app-google-map>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-3 justify-content-center mt-4 mt-md-0">
      <app-support-case-widget
        *appFeature="'CasesSummary'"></app-support-case-widget>
    </div>
  </div>
  <app-weekly-service-calendar
    *appFeature="'ServicesCalendar'"></app-weekly-service-calendar>
</div>
